module.exports = __webpack_public_path__ + "img/title-vn.3ead00dd.png";